const styles = {
  chartPlaceholder: {
    boxShadow: 'none',
  },
  mainHeader: {
    color: '#585858 !important',
    fontSize: '1.125em !important',
    background: '#f7f7f7',
  },
  mainContainer: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '-2rem',
    marginBottom: '2rem',
    marginLeft: 'auto',
  },
  searchContainer: {
    textAlign: 'right',
    '& > button': {
      border: 'none',
      background: 'none',
    },
    border: '0.063rem',
    borderColor: 'rgba(0,0,0,.3)',
    background: '#fafafa',
    borderStyle: 'solid',
    borderRadius: '0.3rem',
    '&:focus-within': {
      borderColor: '#683CAF',
    },
  },
  searchInput: {
    marginLeft: 'none',
    marginRight: 'none',
    border: 'none',
    '&.ui.input>input ': {
      border: 'none !important',
      background: '#fafafa',
    },
  },
  searchByLabel: {
    marginRight: '1rem',
  },
};

export default styles;
